import { useCallback, useMemo } from 'react';
import UISideNavItem from 'UIComponents/nav/UISideNavItem';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { ScreenReaderOnly } from 'foundations-components/transitional/components/ScreenReaderOnly';
import UniversalAssociationsSelectSideNavAccessibilityMessage from './UniversalAssociationsSelectSideNavAccessibilityMessage';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { CAMPAIGNS_OBJECT_TYPE_ID } from 'universal-associations-select/hooks/useFetchHasCampaigns';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UniversalAssociationsSelectSideNavItem = ({
  association,
  onSetSelectedObjectTypeId,
  selectedObjectTypeId
}) => {
  const pluralObjectName = association.get('pluralObjectName');
  const selectedCount = useMemo(() => {
    return association.get('associationOptionRecords').filter(associationOptionRecord => associationOptionRecord.get('isSelected')).size;
  }, [association]);
  const handleSelectNavItem = useCallback(() => {
    const newSelectedObjectTypeId = association.get('toObjectTypeId');
    if (selectedObjectTypeId === newSelectedObjectTypeId) {
      return null;
    }
    return onSetSelectedObjectTypeId(association.get('toObjectTypeId'));
  }, [association, onSetSelectedObjectTypeId, selectedObjectTypeId]);
  const isActive = useMemo(() => {
    return selectedObjectTypeId === association.get('toObjectTypeId');
  }, [association, selectedObjectTypeId]);

  // TODO: Remove this once Campaigns associations have been released for a while.
  const isNew = useMemo(() => {
    return association.get('toObjectTypeId') === CAMPAIGNS_OBJECT_TYPE_ID;
  }, [association]);
  const uniqueIdentifier = association.get('associationTypeId');
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(UISideNavItem, {
      "data-test-id": `universal-associations-select-nav-item-${uniqueIdentifier}`,
      "data-selenium-test": "association-nav",
      "data-selenium-value": pluralObjectName,
      "aria-describedby": `universal-associations-select-nav-item-${uniqueIdentifier}`,
      title: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(TruncateString, {
          children: pluralObjectName
        }), isNew && /*#__PURE__*/_jsx(Badge, {
          use: "new",
          paddingInline: "100",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "universalAssociationsSelect.new"
          })
        })]
      }),
      active: isActive,
      style: isActive ? {
        fontWeight: 'bold'
      } : {},
      count: selectedCount,
      onClick: handleSelectNavItem
    }), /*#__PURE__*/_jsx(ScreenReaderOnly, {
      children: /*#__PURE__*/_jsx("div", {
        id: `universal-associations-select-nav-item-${uniqueIdentifier}`,
        children: /*#__PURE__*/_jsx(UniversalAssociationsSelectSideNavAccessibilityMessage, {
          pluralObjectName: pluralObjectName,
          count: selectedCount
        })
      })
    })]
  });
};
export default UniversalAssociationsSelectSideNavItem;